export const CUSTOM_APP_NAME = 'appName'
export const THEME = 'light'
export const CUSTOM_PRIMARY_BASE = 'primaryColor'
export const CUSTOM_SECONDARY_BASE = 'secondaryColor'
export const NAV_TYPE = 'SIDE'
export const AUTH_TOKEN = 'uid'
export const USER_PK = 'upk'
export const FULL_NAME = 'name'
export const EMAIL = 'email'
export const IMAGE = 'image'
export const E_SIM = 'eSim'
export const PERMISSIONS = 'code'
export const CURRENCY_SYMBOL = 'currency'
export const TITLE = 'role'
export const APPLICATION_URL = 'applicationUrl'
export const APP_STORE_URL = 'appStoreUrl'
export const IPAY_APPLICATION_URL = 'iPayApplicationUrl'
export const SERVICES = 'services'
